import { render, staticRenderFns } from "./PageSummary.vue?vue&type=template&id=3c0d01d1&scoped=true&"
import script from "./PageSummary.vue?vue&type=script&lang=js&"
export * from "./PageSummary.vue?vue&type=script&lang=js&"
import style0 from "./PageSummary.vue?vue&type=style&index=0&id=3c0d01d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d01d1",
  null
  
)

export default component.exports